// i18n strings for /concierge, /government-services, /services
// Same translation policy as TLTB pack: proper nouns / regulatory acronyms
// (FIRCA, RBF, Investor Permit, FRCS, FNPF, EIA, Mataqali, TLTB, Joint Venture)
// remain verbatim in every language since they are the official terms used by
// the Fijian government across all three languages.

const CONCIERGE_EN = {
    heroKicker: "White-Glove Concierge · Productized Engagements",
    heroTitlePre: "Three tiers. ",
    heroTitleAccent: "One outcome:",
    heroTitlePost: "capital deployed in Fiji.",
    heroSubtitle:
        "Every tier is a fixed-price productized engagement — no hourly bills, no scope creep, no surprise invoices. Pay once, receive a dedicated coordinator, and watch milestones hit on your roadmap from kickoff call to ribbon-cut.",
    tiersLoading: "Loading tiers…",
    tierMostPopular: "MOST POPULAR",
    tierCtaBuy: "Get started",
    tierCtaLogin: "Sign in to purchase",
    tierOutcomesLabel: "OUTCOMES BY COMPLETION",
    tierBuyPrefix: "Get",
    trustStripe: { title: "Stripe-secured payments", body: "Card processed via Stripe. We never see or store your card details." },
    trustRefund: { title: "100% refundable for 7 days", body: "If our scoped engagement isn't right, refund within 7 days of purchase — no questions." },
    trustKickoff: { title: "Kickoff within 48h", body: "Once payment clears, your dedicated coordinator emails you within 1 business day with a Calendly link." },
    faqTitle: "Common questions",
    faq: [
        { q: "Why fixed price instead of hourly?", a: "Hourly billing rewards drag. Fixed-price rewards getting it done. Our team is incentivised to close your roadmap fast." },
        { q: "Can I upgrade tiers later?", a: "Yes. Pay the difference and we extend your engagement. Most Explorers upgrade to Investor within 60 days once they see the playbook." },
        { q: "What's the difference between Investor and Developer?", a: "Investor onboards your capital + first deal in 90 days. Developer is for ongoing project orchestration — multi-deal pipelines, council approvals, on-the-ground project management. Pick Developer if you're building something." },
        { q: "Do you have a track record?", a: "See our Hall of Fame for real closed deals. Average uplift on JV-structured landowner deals: +138% above original asking price." },
    ],
    quizPrompt: "Still deciding?",
    quizCta: "Take the 60-second quiz",
    howItWorksKicker: "How it works",
    howItWorksTitle: "Four steps from kickoff to ribbon-cut.",
    howSteps: [
        { title: "Pay & onboard", body: "Stripe checkout, instant receipt, dedicated coordinator assigned within 24 hrs." },
        { title: "Kickoff call", body: "60-min strategy call. We map your goal, timeline, and risk tolerance to the right pipeline." },
        { title: "Milestones tracked", body: "Live dashboard. Every approval, every form, every sign-off — visible to you in real time." },
        { title: "Outcome delivered", body: "Visa stamped. Account opened. Project approved. We don't close the file until you're operational." },
    ],
    safetyKicker: "Safety net",
    safetyTitle: "Productized means predictable.",
    safetyBody:
        "Every tier has a refund policy written into the engagement. If we fail to hit the milestones in the agreed window, you get a pro-rata refund — no negotiation. We are accountable to you, not to billable hours.",
    finalKicker: "Ready to start?",
    finalTitle: "Pick a tier. We do the rest.",
    finalCta: "Browse tiers above",
};

const CONCIERGE_FJ = {
    ...CONCIERGE_EN,
    heroKicker: "Veiqaravi Vakatabakidua · Veiqaravi Vakaivola",
    heroTitlePre: "Tolu na ivakatautoga. ",
    heroTitleAccent: "Dua na inaki:",
    heroTitlePost: "ilavo sa biu mai Viti.",
    heroSubtitle:
        "E ivakarau veivolitaki kece — sega ni isau vakaaua, sega ni veisau ena cakacaka, sega ni invoice ena qaravi. Saumi vakadua, kauti mai e dua na dauveiqaravi, ka raica na ivakatakilakila e laurai mai na soqo ni vakatekivu me yacova na vavakitaki.",
    tiersLoading: "Sa kau mai…",
    tierMostPopular: "DAU GADREVI",
    tierCtaBuy: "Tekivu",
    tierCtaLogin: "Curu mai me volivolitaki",
    tierOutcomesLabel: "INAKI ENA OTI",
    tierBuyPrefix: "Taura",
    trustStripe: { title: "Vakaisau ena Stripe", body: "Na nomu kāde e qaravi ena Stripe. Keimami sega ni raica se maroroya na ikilakila ni nomu kāde." },
    trustRefund: { title: "Vakasuka ena 7 na siga", body: "Ke sega ni vinaka na ivakatautoga, sa rawa ni vakasuka ena 7 na siga — sega ni veivosaki." },
    trustKickoff: { title: "Vakatekivu ena 48 na auwa", body: "Ena lutu mai na isau, na nomu dauveiqaravi ena vakauta na imeli ena dua na siga ni cakacaka kei na sere ni Calendly." },
    faqTitle: "Vinakata na taro?",
    faq: [
        { q: "Cava me isau dei me sega ni isau vakaaua?", a: "Na isau vakaaua e dau guni na cakacaka. Na isau dei e dau vakatotolotaki na cakacaka. Keimami uqeti me vakatotolotaka na nomu vavakitaki." },
        { q: "E rawa beka ni'u vakacolata na ivakatautoga e muri?", a: "Io. Sauma na duidui ka keimami sa kuria na nomu ivakatautoga. Levu na Explorer era vakacolata ki na Investor ena 60 na siga." },
        { q: "Cava na duidui ni Investor kei na Developer?", a: "Investor sa kauta mai na nomu ilavo kei na nomu imatai ni veivolitaki ena 90 na siga. Developer sa baleta na cakacaka veiyabaki — pipeline veivolitaki, vakadonu ni council, qarauni ni projeke ena yasayasa. Digia na Developer ke o tara e dua na ka." },
        { q: "Sa tu beka na nomuni itukutuku?", a: "Raica na Hall of Fame ki na veivolitaki sa cudruvi. Toso ni dauni qele ena JV: +138% mai na isau taumada." },
    ],
    quizPrompt: "Sa lala?",
    quizCta: "Cakava na taro 60 sec",
    howItWorksKicker: "Sa cava na ivakarau",
    howItWorksTitle: "Va na isteba mai na vakatekivu ki na vavakitaki.",
    howSteps: [
        { title: "Sauma & curu", body: "Stripe checkout, isau vakavotutaki, dauveiqaravi sa qarauni cake mai ena 24 hr." },
        { title: "Soqo ni vakatekivu", body: "60 mn ni veivosaki ni naki. Keimami vakatuva na nomu inaki, gauna, kei na yavu ni risk." },
        { title: "Vakatari ivakatakilakila", body: "Idashboard bula. Na vakadonu kece, na ivola kece, na isaini kece — rai vakatotolo." },
        { title: "Solia na inaki", body: "Visa sa stamped. Na akaude sa dolavi. Projeke sa donu. Keimami sega ni sogota me yacova ni o caka." },
    ],
    safetyKicker: "Lala ni veitaqomaki",
    safetyTitle: "Vakaivola e kena ibalebale dei.",
    safetyBody:
        "E tu kina e dua na ivakarau ni vakasuka ena dua na ivakatautoga. Ke keimami sega ni yacova na ivakatakilakila ena gauna donu, sa rawa kina na vakasuka ni ilavo donu — sega ni veivosaki. Keimami tu ena nomuni dodonu, sega ena ivola ni qaqaravi.",
    finalKicker: "Sa rawa ni tekivu?",
    finalTitle: "Digia e dua na ivakatautoga. Keimami qaravi na vo.",
    finalCta: "Raica na ivakatautoga e cake",
};

const CONCIERGE_HI = {
    ...CONCIERGE_EN,
    heroKicker: "व्हाइट-ग्लोव कंसीयज · प्रोडक्टाइज़्ड एंगेजमेंट",
    heroTitlePre: "तीन स्तर। ",
    heroTitleAccent: "एक परिणाम:",
    heroTitlePost: "फिजी में पूँजी की तैनाती।",
    heroSubtitle:
        "हर स्तर एक निश्चित-मूल्य प्रोडक्टाइज़्ड एंगेजमेंट है — कोई घंटे का बिल नहीं, कोई स्कोप क्रीप नहीं, कोई आश्चर्यजनक चालान नहीं। एक बार भुगतान करें, एक समर्पित समन्वयक प्राप्त करें, और किकऑफ़ कॉल से रिबन-कट तक अपने रोडमैप पर मील के पत्थर देखें।",
    tiersLoading: "स्तर लोड हो रहे हैं…",
    tierMostPopular: "सबसे लोकप्रिय",
    tierCtaBuy: "शुरू करें",
    tierCtaLogin: "खरीदने के लिए साइन इन करें",
    tierOutcomesLabel: "पूर्णता पर परिणाम",
    tierBuyPrefix: "खरीदें",
    trustStripe: { title: "Stripe-सुरक्षित भुगतान", body: "कार्ड Stripe के माध्यम से संसाधित। हम आपके कार्ड विवरण कभी नहीं देखते या संग्रहीत करते।" },
    trustRefund: { title: "7 दिनों के लिए 100% धनवापसी योग्य", body: "यदि हमारा एंगेजमेंट सही नहीं है, तो खरीद के 7 दिनों के भीतर वापसी — कोई प्रश्न नहीं।" },
    trustKickoff: { title: "48 घंटे में किकऑफ़", body: "भुगतान साफ़ होते ही, आपका समर्पित समन्वयक 1 कार्यदिवस के भीतर Calendly लिंक के साथ आपको ईमेल करता है।" },
    faqTitle: "सामान्य प्रश्न",
    faq: [
        { q: "घंटे के बजाय निश्चित मूल्य क्यों?", a: "घंटे के हिसाब से बिलिंग देरी को पुरस्कृत करती है। निश्चित-मूल्य काम पूरा करने को पुरस्कृत करता है। हमारी टीम आपके रोडमैप को तेज़ी से बंद करने के लिए प्रोत्साहित है।" },
        { q: "क्या मैं बाद में स्तर अपग्रेड कर सकता हूँ?", a: "हाँ। अंतर का भुगतान करें और हम आपके एंगेजमेंट का विस्तार करते हैं। अधिकांश Explorers 60 दिनों के भीतर Investor पर अपग्रेड करते हैं।" },
        { q: "Investor और Developer में क्या अंतर है?", a: "Investor आपकी पूँजी + पहला सौदा 90 दिनों में ऑनबोर्ड करता है। Developer चालू परियोजना समन्वय के लिए है — बहु-सौदा पाइपलाइन, परिषद अनुमोदन, परियोजना प्रबंधन। Developer चुनें यदि आप कुछ बना रहे हैं।" },
        { q: "क्या आपका ट्रैक रिकॉर्ड है?", a: "वास्तविक बंद सौदों के लिए हमारा Hall of Fame देखें। JV-संरचित भूस्वामी सौदों पर औसत वृद्धि: मूल मूल्य से +138% ऊपर।" },
    ],
    quizPrompt: "अभी भी निर्णय ले रहे हैं?",
    quizCta: "60-सेकंड क्विज़ लें",
    howItWorksKicker: "यह कैसे काम करता है",
    howItWorksTitle: "किकऑफ़ से रिबन-कट तक चार चरण।",
    howSteps: [
        { title: "भुगतान और ऑनबोर्ड", body: "Stripe चेकआउट, तत्काल रसीद, 24 घंटे के भीतर समर्पित समन्वयक सौंपा गया।" },
        { title: "किकऑफ़ कॉल", body: "60 मिनट की रणनीति कॉल। हम आपके लक्ष्य, समयरेखा और जोखिम सहनशीलता को सही पाइपलाइन से मैप करते हैं।" },
        { title: "मील के पत्थर ट्रैक", body: "लाइव डैशबोर्ड। हर अनुमोदन, हर फ़ॉर्म, हर साइन-ऑफ़ — आपको रीयल-टाइम में दिखाई देता है।" },
        { title: "परिणाम वितरित", body: "वीज़ा मुहर। खाता खोला गया। परियोजना अनुमोदित। जब तक आप परिचालन में नहीं होते, हम फ़ाइल बंद नहीं करते।" },
    ],
    safetyKicker: "सुरक्षा जाल",
    safetyTitle: "प्रोडक्टाइज़्ड का अर्थ है पूर्वानुमेय।",
    safetyBody:
        "हर स्तर में एंगेजमेंट में लिखी गई एक रिफंड नीति होती है। यदि हम सहमत खिड़की में मील के पत्थर हिट करने में विफल होते हैं, तो आपको प्रो-राटा रिफंड मिलता है — कोई बातचीत नहीं। हम आपके प्रति जवाबदेह हैं, बिल योग्य घंटों के प्रति नहीं।",
    finalKicker: "शुरू करने के लिए तैयार?",
    finalTitle: "एक स्तर चुनें। बाकी हम करते हैं।",
    finalCta: "ऊपर के स्तर देखें",
};


const GOVERNMENT_EN = {
    heroKicker: "Government Liaison Hub · 12+ Agencies",
    heroTitlePre: "We talk to ",
    heroTitleAccent: "every Fiji ministry",
    heroTitlePost: "so you don't have to.",
    heroSubtitle:
        "FIRCA, Reserve Bank of Fiji, Department of Immigration, Fiji Revenue & Customs, Department of Environment, Town & Country Planning, FNPF — every approval that touches your investment, coordinated by us, on your timeline.",
    heroCtaPrimary: "Book a coordination call",
    heroCtaSecondary: "View all agencies",
    statsAgencies: "Agencies covered",
    statsContact: "Point of contact",
    statsForms: "Forms you fill in",
    bodyTitle: "The agencies. The pain. What we handle.",
    bodyIntro:
        "Click any agency to request handling. We'll reply within one business day with a scoped engagement and timeline.",
    agencyLabelPrefix: "Agency",
    scopeLabel: "Scope",
    painLabel: "The pain",
    handleLabel: "What we handle",
    handleCta: "We handle this for you",
    bottomCtaTitle: "Need more than one agency handled?",
    bottomCtaBody:
        "Most projects touch 4–6 of these. Our Concierge tiers bundle them — Investor and Developer tiers coordinate every agency you'll need, end-to-end.",
    bottomCtaPrimary: "View Concierge tiers",
    bottomCtaSecondary: "Take the 60-second quiz",
    agenciesKicker: "Agencies we coordinate",
    agenciesTitle: "Twelve+ relationships. One coordinator.",
    agenciesIntro:
        "Every approval below is handled by a named coordinator with a direct relationship at the agency. We don't 'submit forms' — we walk applications through the building.",
    timelineKicker: "Typical timeline",
    timelineTitle: "From discovery to operational, 90–180 days.",
    timelineDays: [
        { range: "Days 0–14", title: "Investor Permit lodgement", body: "Department of Immigration — application, supporting docs, biometrics window." },
        { range: "Days 14–30", title: "FIRCA approval", body: "Foreign Investment Registration Certificate prep + lodgement." },
        { range: "Days 30–60", title: "Banking + entity formation", body: "Companies Office + FRCS TIN + FNPF + bank introduction in parallel." },
        { range: "Days 60–120", title: "Council planning + EIA", body: "Local council planning consent + Environment Impact (resort/coastal projects)." },
        { range: "Days 120–180", title: "Tax incentives + operational", body: "Tourism Hotel Aid Act, SLIP, sectoral allowances filed; project goes live." },
    ],
    finalKicker: "Ready to start?",
    finalTitle: "Book the call.",
    finalSub:
        "60 minutes. We map your project to the agencies. You leave with a written timeline.",
    finalCta: "Schedule coordination call",
};

const GOVERNMENT_FJ = {
    ...GOVERNMENT_EN,
    heroKicker: "Itokatoka ni Matanitu · 12+ Tabana",
    heroTitlePre: "Keimami veitalanoa kei na ",
    heroTitleAccent: "tabana kece e Viti",
    heroTitlePost: "me sega ni baleti iko.",
    heroSubtitle:
        "FIRCA, Reserve Bank of Fiji, Tabana ni Vakauruci, FRCS, Tabana ni Vanua, Naki ni Koro, FNPF — na vakadonu kece e tara na nomu ilavo, qaravi vata, ena nomu gauna.",
    heroCtaPrimary: "Kerea na soqo",
    heroCtaSecondary: "Raica na tabana kece",
    statsAgencies: "Tabana qaravi",
    statsContact: "Cala ni veisemati",
    statsForms: "Ivola me vakasinaiti",
    bodyTitle: "Na tabana. Na leqa. Cava keimami qaravi.",
    bodyIntro:
        "Cikira e dua na tabana me kerei kina na veiqaravi. Keimami sauma ena dua na siga ni cakacaka kei na ivakatautoga sa volai.",
    agencyLabelPrefix: "Tabana",
    scopeLabel: "Yavu",
    painLabel: "Na leqa",
    handleLabel: "Cava keimami qaravi",
    handleCta: "Keimami qarava me baleti iko",
    bottomCtaTitle: "Vinakata e levu na tabana me qaravi?",
    bottomCtaBody:
        "Levu na projeke e tara 4–6. Na ivakatautoga ni Concierge sa vauci kece — na Investor kei Developer sa qarava na tabana kece.",
    bottomCtaPrimary: "Raica na Concierge",
    bottomCtaSecondary: "Cakava na taro 60 sec",
    agenciesKicker: "Tabana keimami qaravi",
    agenciesTitle: "Tinikarua+ na veisemati. Dua na dauveiqaravi.",
    agenciesIntro:
        "Na vakadonu kece e koto e ra qaravi kina e dua na dauveiqaravi sa volai e dua na veisemati vakadua kei na tabana. Keimami sega ni 'soli ivola' — keimami kauta na isoli ena loma ni vale.",
    timelineKicker: "Gauna dau yaco kina",
    timelineTitle: "Mai na vakatekivu ki na cakacaka, 90–180 na siga.",
    timelineDays: [
        { range: "Siga 0–14", title: "Soli ni Investor Permit", body: "Tabana ni Vakauruci — isoli, ivola ni veitokoni, gauna ni biometric." },
        { range: "Siga 14–30", title: "Vakadonu ni FIRCA", body: "Vakarautaki kei na soli ni Foreign Investment Registration Certificate." },
        { range: "Siga 30–60", title: "Banking + cakacaka ni kabani", body: "Companies Office + FRCS TIN + FNPF + biloko ena dua na sala." },
        { range: "Siga 60–120", title: "Naki ni koro + EIA", body: "Vakadonu ni naki ni koro + EIA (na vanua ni saravanua)." },
        { range: "Siga 120–180", title: "Veivuke vakatevoro + cakacaka", body: "Tourism Hotel Aid Act, SLIP, kei na so tale sa volai; projeke sa cakacaka." },
    ],
    finalKicker: "Sa rawa ni tekivu?",
    finalTitle: "Vakarautaki na veitalanoa.",
    finalSub:
        "60 mn. Keimami vakatuva na nomu projeke ki na tabana. O na biuti kei na gauna sa volai.",
    finalCta: "Vakarautaki na soqo",
};

const GOVERNMENT_HI = {
    ...GOVERNMENT_EN,
    heroKicker: "सरकारी संपर्क हब · 12+ एजेंसियाँ",
    heroTitlePre: "हम ",
    heroTitleAccent: "हर फिजी मंत्रालय",
    heroTitlePost: "से बात करते हैं ताकि आपको न करनी पड़े।",
    heroSubtitle:
        "FIRCA, Reserve Bank of Fiji, Department of Immigration, FRCS, Department of Environment, Town & Country Planning, FNPF — हर अनुमोदन जो आपके निवेश को छूता है, हमारे द्वारा समन्वित, आपकी समयरेखा पर।",
    heroCtaPrimary: "समन्वय कॉल बुक करें",
    heroCtaSecondary: "सभी एजेंसियाँ देखें",
    statsAgencies: "एजेंसियाँ कवर",
    statsContact: "संपर्क बिंदु",
    statsForms: "आपके भरने वाले फ़ॉर्म",
    bodyTitle: "एजेंसियाँ। दर्द। हम क्या संभालते हैं।",
    bodyIntro:
        "किसी भी एजेंसी पर क्लिक करें ताकि उसका प्रबंधन अनुरोध करें। हम 1 कार्यदिवस में स्कोप किए गए एंगेजमेंट और समयरेखा के साथ उत्तर देंगे।",
    agencyLabelPrefix: "एजेंसी",
    scopeLabel: "क्षेत्र",
    painLabel: "दर्द",
    handleLabel: "हम क्या संभालते हैं",
    handleCta: "हम आपके लिए इसे संभालते हैं",
    bottomCtaTitle: "एक से अधिक एजेंसी संभालने की आवश्यकता है?",
    bottomCtaBody:
        "अधिकांश परियोजनाएँ 4–6 को छूती हैं। हमारे Concierge स्तर उन्हें बंडल करते हैं — Investor और Developer स्तर हर एजेंसी का समन्वय करते हैं।",
    bottomCtaPrimary: "Concierge स्तर देखें",
    bottomCtaSecondary: "60-सेकंड क्विज़ लें",
    agenciesKicker: "एजेंसियाँ जिनका हम समन्वय करते हैं",
    agenciesTitle: "बारह+ संबंध। एक समन्वयक।",
    agenciesIntro:
        "नीचे हर अनुमोदन एक नामित समन्वयक द्वारा संभाला जाता है जिसका एजेंसी में सीधा संबंध है। हम 'फ़ॉर्म जमा' नहीं करते — हम भवन के माध्यम से आवेदनों को आगे ले जाते हैं।",
    timelineKicker: "विशिष्ट समयरेखा",
    timelineTitle: "खोज से परिचालन तक, 90–180 दिन।",
    timelineDays: [
        { range: "दिन 0–14", title: "Investor Permit लॉजमेंट", body: "Department of Immigration — आवेदन, सहायक दस्तावेज़, बायोमेट्रिक्स विंडो।" },
        { range: "दिन 14–30", title: "FIRCA अनुमोदन", body: "Foreign Investment Registration Certificate तैयारी + दाखिला।" },
        { range: "दिन 30–60", title: "बैंकिंग + इकाई गठन", body: "Companies Office + FRCS TIN + FNPF + बैंक परिचय समानांतर में।" },
        { range: "दिन 60–120", title: "परिषद योजना + EIA", body: "स्थानीय परिषद योजना सहमति + पर्यावरण प्रभाव (रिज़ॉर्ट/तटीय परियोजनाएँ)।" },
        { range: "दिन 120–180", title: "कर प्रोत्साहन + परिचालन", body: "Tourism Hotel Aid Act, SLIP, क्षेत्रीय भत्ते दाखिल; परियोजना लाइव होती है।" },
    ],
    finalKicker: "शुरू करने के लिए तैयार?",
    finalTitle: "कॉल बुक करें।",
    finalSub:
        "60 मिनट। हम आपकी परियोजना को एजेंसियों से मैप करते हैं। आप एक लिखित समयरेखा के साथ निकलते हैं।",
    finalCta: "समन्वय कॉल शेड्यूल करें",
};


const SERVICES_EN = {
    heroKicker: "Service Suite · End-to-End Foreign Investment",
    heroTitlePre: "Every service. ",
    heroTitleAccent: "One platform.",
    heroSubtitle:
        "From the first scout call to the final ribbon-cut, every service touch a foreign investor needs in Fiji — managed by us, billed once, delivered on schedule.",
    heroCtaPrimary: "View all services",
    heroCtaSecondary: "Browse Concierge tiers",
    statsCategories: "Service categories",
    statsAgencies: "Govt agencies covered",
    statsContact: "Point of contact",
    bodyTitle: "Everything you need — under one roof.",
    bodyIntro:
        "Click any category to request assistance. Our team responds within one business day.",
    moreLabel: "more",
    requestCta: "Request assistance",
    bottomTitle: "Not sure where to start?",
    bottomBody:
        "Tell us your investment thesis and timeline. We map the right service stack and book a 30-minute strategy call to walk you through it.",
    bottomCta: "Talk to us about Fiji",
    loadingLabel: "Loading services…",
    lanesKicker: "Service lanes",
    lanesTitle: "Pick your lane. We meet you there.",
    lanesIntro:
        "Whether you're a foreign buyer, a landowner, or a Fijian agent — there's a defined lane for you, with the right tools and the right tier of support attached.",
    lanesList: [
        { id: "investor", label: "Foreign Investor", body: "Vetted opportunities, structured JVs, full compliance lift." },
        { id: "landowner", label: "Fijian Landowner", body: "JV pathways for native lease, freehold, or crown lease." },
        { id: "agent", label: "Real-Estate Agent", body: "Listings, leads, and the JV-conversion engine." },
        { id: "business_seller", label: "Business Seller", body: "Confidential listings, NDA gating, vetted buyers only." },
        { id: "business_buyer", label: "Business Buyer", body: "Operating businesses for sale across tourism, agri, services." },
    ],
    finalKicker: "Stuck on which lane?",
    finalTitle: "Talk to a coordinator.",
    finalSub:
        "Free 30-min call. We figure out the right service path together — no commitment.",
    finalCta: "Book a free call",
};

const SERVICES_FJ = {
    ...SERVICES_EN,
    heroKicker: "Veiqaravi · Cakacaka Vakaivolasiga",
    heroTitlePre: "Veiqaravi kece. ",
    heroTitleAccent: "Dua na yavu.",
    heroSubtitle:
        "Mai na veisureti taumada ki na vavakitaki, na veiqaravi kece e gadreva e dua na dauveiqaravi mai vanua tani ena Viti — qaravi vata, isau vakadua, soli ena gauna donu.",
    heroCtaPrimary: "Raica na veiqaravi kece",
    heroCtaSecondary: "Raica na Concierge",
    statsCategories: "Sotari ni veiqaravi",
    statsAgencies: "Tabana ni matanitu",
    statsContact: "Cala ni veisemati",
    bodyTitle: "Veiqaravi kece — ena dua na vale.",
    bodyIntro:
        "Cikira e dua na sotari me kerei kina na veitokoni. Keimami sauma ena dua na siga ni cakacaka.",
    moreLabel: "tale",
    requestCta: "Kerea na veitokoni",
    bottomTitle: "Sa lala na nomu vakatekivu?",
    bottomBody:
        "Tukuna na nomu inaki kei na gauna. Keimami vakatuva na veiqaravi donu kei na nodra vakarautaki na soqo ni 30 mn me vakaraitaka kina.",
    bottomCta: "Veitalanoa kei keimami baleta na Viti",
    loadingLabel: "Sa kau mai na veiqaravi…",
    lanesKicker: "Sala ni veiqaravi",
    lanesTitle: "Digia na nomu sala. Keimami sotari.",
    lanesIntro:
        "Ke o dauveiqaravi mai vanua tani, dauni qele, se dauveivolitaki — sa tu e dua na sala vei iko, kei na iyaragi donu kei na ivakatautoga ni veitokoni.",
    lanesList: [
        { id: "investor", label: "Dauveiqaravi mai Vanua Tani", body: "Vanua sa qaravi, JV vakaivola, vakauasivi ni cakacaka." },
        { id: "landowner", label: "Dauni Qele Vakaviti", body: "Sala ni JV ena lisi vakaviti, freehold, se crown lease." },
        { id: "agent", label: "Dauveivolitaki", body: "Veivolitaki, leads, kei na yavu ni sosomitaki ni JV." },
        { id: "business_seller", label: "Dauveivoli ni Bisinisi", body: "Veivolitaki vakatabu, NDA, dauvolivoli sa qaravi." },
        { id: "business_buyer", label: "Dauvoli ni Bisinisi", body: "Bisinisi sa cakacaka ena saravanua, vakaqele, veiqaravi." },
    ],
    finalKicker: "Sa lala na nomu sala?",
    finalTitle: "Veitalanoa kei na dauveiqaravi.",
    finalSub:
        "30 mn ni veitalanoa lala. Keimami vakatuva vata na sala donu — sega ni vakadeitaki.",
    finalCta: "Vakarautaki na veitalanoa lala",
};

const SERVICES_HI = {
    ...SERVICES_EN,
    heroKicker: "सेवा सूट · एंड-टू-एंड विदेशी निवेश",
    heroTitlePre: "हर सेवा। ",
    heroTitleAccent: "एक मंच।",
    heroSubtitle:
        "पहली स्काउट कॉल से अंतिम रिबन-कट तक, फिजी में विदेशी निवेशक को जिस भी सेवा की आवश्यकता हो — हमारे द्वारा प्रबंधित, एक बार बिल किया गया, समय पर वितरित।",
    heroCtaPrimary: "सभी सेवाएँ देखें",
    heroCtaSecondary: "Concierge स्तर देखें",
    statsCategories: "सेवा श्रेणियाँ",
    statsAgencies: "सरकारी एजेंसियाँ",
    statsContact: "संपर्क बिंदु",
    bodyTitle: "जो आपको चाहिए — एक छत के नीचे।",
    bodyIntro:
        "सहायता का अनुरोध करने के लिए किसी भी श्रेणी पर क्लिक करें। हमारी टीम 1 कार्यदिवस के भीतर उत्तर देती है।",
    moreLabel: "और",
    requestCta: "सहायता का अनुरोध करें",
    bottomTitle: "कहाँ से शुरू करें, सुनिश्चित नहीं?",
    bottomBody:
        "अपनी निवेश थीसिस और समयरेखा बताएँ। हम सही सेवा स्टैक मैप करते हैं और आपको इसके माध्यम से चलने के लिए 30-मिनट की रणनीति कॉल बुक करते हैं।",
    bottomCta: "फिजी के बारे में हमसे बात करें",
    loadingLabel: "सेवाएँ लोड हो रही हैं…",
    lanesKicker: "सेवा लेन",
    lanesTitle: "अपनी लेन चुनें। हम वहाँ आपसे मिलते हैं।",
    lanesIntro:
        "चाहे आप विदेशी क्रेता हों, भूस्वामी हों, या फिजियाई एजेंट हों — आपके लिए एक परिभाषित लेन है, सही उपकरणों और सहायता के सही स्तर के साथ।",
    lanesList: [
        { id: "investor", label: "विदेशी निवेशक", body: "जाँचे हुए अवसर, संरचित JV, पूर्ण अनुपालन।" },
        { id: "landowner", label: "फिजियाई भूस्वामी", body: "मूल पट्टे, फ्रीहोल्ड, या क्राउन लीज़ के लिए JV मार्ग।" },
        { id: "agent", label: "रियल-एस्टेट एजेंट", body: "लिस्टिंग, लीड और JV-रूपांतरण इंजन।" },
        { id: "business_seller", label: "व्यवसाय विक्रेता", body: "गोपनीय लिस्टिंग, NDA गेटिंग, केवल सत्यापित क्रेता।" },
        { id: "business_buyer", label: "व्यवसाय क्रेता", body: "पर्यटन, कृषि, सेवाओं में बिक्री के लिए परिचालित व्यवसाय।" },
    ],
    finalKicker: "किस लेन पर अटके हैं?",
    finalTitle: "एक समन्वयक से बात करें।",
    finalSub:
        "30 मिनट की मुफ़्त कॉल। हम मिलकर सही सेवा पथ पता करते हैं — कोई प्रतिबद्धता नहीं।",
    finalCta: "मुफ़्त कॉल बुक करें",
};


const PAGE_DICTS = {
    concierge: { en: CONCIERGE_EN, fj: CONCIERGE_FJ, hi: CONCIERGE_HI },
    government: { en: GOVERNMENT_EN, fj: GOVERNMENT_FJ, hi: GOVERNMENT_HI },
    services: { en: SERVICES_EN, fj: SERVICES_FJ, hi: SERVICES_HI },
};

export function getPageStrings(page, lang) {
    const dict = PAGE_DICTS[page];
    if (!dict) return {};
    return dict[lang] || dict.en;
}
